<template>
    <section>
        <!-- <hr > -->
        <div class="container-fluid">
            <!---Start Of Student Reviews-->
            <section class="student-reviews">
                <div class="mb-5 mt-5 student-reviews-1">
                    <div class="student-reviews-2">
                        <Carousel :wrap-around="true" :autoplay="4000" :transition="600" :dir="direction"
                            v-bind="settings" :breakpoints="breakpoints">
                            <Slide v-for="slide, i in slidesContent" :key="i">
                                <!-----------start------------------>
                                <div class="profile-cards">
                                    <div class="card w-100">
                                        <div class="content-1 ">
                                            <div class="stats">
                                                <div class="">
                                                    <div class="d-flex align-items-md-center flex-column flex-md-row">
                                                        <div class="img-box">
                                                            <img loading="lazy"
                                                                :src="`${AssestURL}/${slide?.userPicture}`"
                                                                :alt="slide?.userName || 'User Photo'" width="200"
                                                                height="200"
                                                                @error="(e) => e.target.src = require('@/assets/images/profile-img.jpg')" />
                                                            <!-- <img loading="lazy"
                                                                :src="`${AssestURL}/${slide?.userPicture}`"
                                                                v-if="slide?.userPicture" :alt="slide?.userName"
                                                                width="200px" height="200px" />
                                                            <img v-else src="../../assets/images/profile-img.jpg"
                                                                alt="Default User Photo" class="profile-photo" /> -->
                                                        </div>
                                                        <div class="name-container">
                                                            <h2 class="name">{{ slide?.userName }} </h2>
                                                            <span class="overflow-hidden">
                                                                <rating-component :rating="slide?.rate" />
                                                                <!-- <StarRating :rating="slide?.rate" star-size="30"
                                                                    :read-only="true" :show-rating="false" /> -->
                                                            </span>
                                                        </div>

                                                        <!-- <div class="like" v-show="hideLike">
                                                            <span>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path
                                                                        d="M15 14L14.26 14.123C14.2421 14.0156 14.2479 13.9055 14.2769 13.8005C14.3058 13.6955 14.3573 13.5981 14.4277 13.515C14.4982 13.432 14.5858 13.3652 14.6847 13.3194C14.7835 13.2737 14.8911 13.25 15 13.25V14ZM4 14V14.75C3.80109 14.75 3.61032 14.671 3.46967 14.5303C3.32902 14.3897 3.25 14.1989 3.25 14H4ZM6 3.25H17.36V4.75H6V3.25ZM18.56 14.75H15V13.25H18.56V14.75ZM15.74 13.877L16.546 18.712L15.066 18.959L14.26 14.123L15.74 13.877ZM14.82 20.75H14.606V19.25H14.819L14.82 20.75ZM11.485 19.08L8.97 15.307L10.218 14.475L12.733 18.248L11.485 19.08ZM7.93 14.75H4V13.25H7.93V14.75ZM3.25 14V6H4.75V14H3.25ZM20.057 5.46L21.257 11.46L19.787 11.755L18.587 5.755L20.057 5.46ZM8.97 15.307C8.8559 15.1357 8.70127 14.9963 8.51985 14.8991C8.33842 14.8019 8.13581 14.7511 7.93 14.751V13.251C8.85 13.251 9.708 13.71 10.218 14.475L8.97 15.307ZM16.546 18.712C16.5878 18.9627 16.5745 19.2205 16.5071 19.4656C16.4396 19.7106 16.3196 19.938 16.1553 20.132C15.991 20.3259 15.7865 20.4818 15.5559 20.5887C15.3253 20.6956 15.0742 20.75 14.82 20.75V19.251C14.8562 19.2509 14.892 19.2429 14.9249 19.2276C14.9578 19.2123 14.9869 19.1901 15.0103 19.1624C15.0337 19.1347 15.0508 19.1023 15.0604 19.0673C15.07 19.0324 15.0719 18.9948 15.066 18.959L16.546 18.712ZM18.56 13.251C18.7449 13.251 18.9276 13.21 19.0948 13.1309C19.262 13.0519 19.4095 12.9366 19.5268 12.7936C19.6441 12.6506 19.7282 12.4834 19.773 12.3039C19.8178 12.1245 19.8222 11.9374 19.786 11.756L21.257 11.461C21.3367 11.86 21.327 12.2727 21.2284 12.6674C21.1298 13.0622 20.9448 13.4301 20.6868 13.7447C20.4288 14.0593 20.1042 14.3128 19.7365 14.4868C19.3687 14.6608 18.9669 14.7511 18.56 14.751V13.251ZM17.36 3.25C17.9957 3.24988 18.6118 3.471 19.1035 3.87392C19.5952 4.27684 19.9322 4.83667 20.057 5.46L18.587 5.755C18.5305 5.47122 18.3773 5.21682 18.1536 5.03336C17.9298 4.84991 17.6494 4.74976 17.36 4.75V3.25ZM14.606 20.75C13.9887 20.75 13.3809 20.5985 12.8366 20.3072C12.2923 20.0159 11.8284 19.5947 11.486 19.081L12.733 18.249C12.9385 18.5573 13.2171 18.8101 13.5438 18.9849C13.8706 19.1597 14.2354 19.2501 14.606 19.25V20.75ZM6 4.75C5.31 4.75 4.75 5.31 4.75 6H3.25C3.25 5.27065 3.53973 4.57118 4.05546 4.05546C4.57118 3.53973 5.27065 3.25 6 3.25V4.75Z"
                                                                        fill="#263238" />
                                                                    <path d="M8 14V4V14Z" fill="#263238" />
                                                                    <path d="M8 14V4" stroke="black"
                                                                        stroke-width="0.5" />
                                                                </svg>
                                                            </span>
                                                            <span>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path
                                                                        d="M15 10L14.507 9.918C14.4951 9.9896 14.4989 10.0629 14.5182 10.1329C14.5375 10.2029 14.5718 10.2678 14.6187 10.3232C14.6656 10.3786 14.724 10.4231 14.7899 10.4536C14.8557 10.4841 14.9274 10.5 15 10.5V10ZM4 10V9.5C3.86739 9.5 3.74021 9.55268 3.64645 9.64645C3.55268 9.74021 3.5 9.86739 3.5 10H4ZM6 20.5H17.36V19.5H6V20.5ZM18.56 9.5H15V10.5H18.56V9.5ZM15.493 10.082L16.299 5.247L15.313 5.082L14.507 9.918L15.493 10.082ZM14.82 3.5H14.607V4.5H14.82V3.5ZM11.694 5.059L9.178 8.832L10.01 9.387L12.525 5.613L11.694 5.059ZM7.93 9.5H4V10.5H7.93V9.5ZM3.5 10V18H4.5V10H3.5ZM19.812 18.49L21.012 12.49L20.032 12.294L18.832 18.294L19.812 18.49ZM9.178 8.832C9.04103 9.03747 8.85546 9.20594 8.63775 9.32247C8.42004 9.439 8.17693 9.49998 7.93 9.5V10.5C8.34153 10.5 8.74669 10.3984 9.10954 10.2043C9.47238 10.0101 9.78169 9.72938 10.01 9.387L9.178 8.832ZM16.299 5.247C16.3349 5.03214 16.3235 4.81203 16.2657 4.602C16.2079 4.39197 16.1051 4.19705 15.9643 4.03079C15.8236 3.86453 15.6483 3.73093 15.4507 3.63926C15.253 3.5476 15.0378 3.50008 14.82 3.5V4.5C14.8927 4.49989 14.9645 4.51562 15.0304 4.54609C15.0964 4.57656 15.1549 4.62104 15.202 4.67644C15.249 4.73184 15.2834 4.79682 15.3027 4.86686C15.3221 4.9369 15.3259 5.01032 15.314 5.082L16.299 5.247ZM18.56 10.5C18.7819 10.5 19.0011 10.5492 19.2017 10.6441C19.4023 10.7391 19.5793 10.8773 19.72 11.0489C19.8607 11.2205 19.9616 11.4212 20.0154 11.6365C20.0692 11.8518 20.0755 12.0764 20.032 12.294L21.012 12.49C21.0845 12.1274 21.0746 11.7533 20.9851 11.3946C20.8955 11.0359 20.7276 10.7015 20.4932 10.4155C20.2589 10.1295 19.964 9.89907 19.6299 9.74076C19.2958 9.58245 18.9307 9.50022 18.561 9.5L18.56 10.5ZM17.36 20.5C17.9381 20.5001 18.4983 20.2999 18.9454 19.9334C19.3925 19.5669 19.6987 19.0569 19.812 18.49L18.832 18.294C18.764 18.6343 18.5801 18.9404 18.3117 19.1603C18.0433 19.3802 17.707 19.5003 17.36 19.5V20.5ZM14.606 3.5C14.0296 3.49991 13.4621 3.64217 12.954 3.91414C12.4458 4.18611 12.0126 4.57937 11.693 5.059L12.525 5.613C12.7533 5.27062 13.0626 4.98989 13.4255 4.79573C13.7883 4.60158 14.1935 4.49999 14.605 4.5L14.606 3.5ZM6 19.5C5.60218 19.5 5.22064 19.342 4.93934 19.0607C4.65804 18.7794 4.5 18.3978 4.5 18H3.5C3.5 18.3283 3.56466 18.6534 3.6903 18.9567C3.81594 19.26 4.00009 19.5356 4.23223 19.7678C4.46438 19.9999 4.73998 20.1841 5.04329 20.3097C5.34661 20.4353 5.6717 20.5 6 20.5V19.5Z"
                                                                        fill="#263238" />
                                                                    <path d="M8 10V20V10Z" fill="#263238" />
                                                                    <path d="M8 10V20" stroke="black" />
                                                                </svg>
                                                            </span>
                                                        </div> -->
                                                    </div>
                                                    <p class="text">
                                                        {{ slide?.comment }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-------------end------------------->
                            </Slide>
                            <template #addons>
                                <navigation>
                                    <template #next>
                                        <span>
                                            <i class="fa-solid fa-arrow-left-long"></i></span>
                                    </template>
                                    <template #prev>
                                        <span> <i class="fa-solid fa-arrow-right-long"></i> </span>
                                    </template>
                                </navigation>
                                <Pagination />
                            </template>
                        </Carousel>
                    </div>
                </div>
            </section>
            <!---End Of students Reviews-->
        </div>
        <!--------Add Your opnion---------------------->
        <!--
    <hr>
     <section :class="applyContainer ? 'custom-container-1' : ''">
        <div class="add-review">
            <h4>
                {{ $t('addReview') }}
            </h4>
            <div class="d-flex flex-column flex-md-row rate">
                <p>
                    {{ $t('courseRating') }}
                </p>
                <p class="d-flex gap-3">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11.7303 3.23485C11.2803 3.8218 10.7733 4.72849 10.0356 6.05084L9.66222 6.72115L9.59485 6.84219C9.25227 7.45883 8.96108 7.98184 8.49403 8.33583C8.02242 8.6944 7.44689 8.82344 6.77772 8.97417L6.64754 9.00386L5.92127 9.1683C4.48816 9.49261 3.51181 9.71528 2.84492 9.97906C2.19288 10.2349 2.05585 10.4461 2.00333 10.614C1.94737 10.7921 1.94623 11.065 2.33448 11.684C2.73073 12.312 3.39876 13.0954 4.37396 14.2373L4.86956 14.8163L4.9552 14.9156C5.4154 15.4523 5.79909 15.9 5.97494 16.4663C6.14966 17.0293 6.09142 17.6197 6.02062 18.3368L6.0092 18.4704L5.93384 19.2435C5.78538 20.7646 5.68718 21.8128 5.72029 22.5665C5.75455 23.3202 5.91328 23.528 6.04003 23.6239C6.15194 23.7096 6.35977 23.8032 7.03694 23.6091C7.72552 23.4127 8.64134 22.9936 9.98311 22.3758L10.6637 22.0629L10.7882 22.0058C11.4105 21.7169 11.9495 21.468 12.5387 21.468C13.128 21.468 13.667 21.7169 14.2893 22.0047C14.3308 22.0246 14.3726 22.0437 14.4149 22.0618L15.0944 22.3758C16.4361 22.9936 17.352 23.4127 18.0405 23.6091C18.7177 23.8032 18.9255 23.7096 19.0374 23.6239C19.1642 23.528 19.3229 23.319 19.3572 22.5665C19.3914 21.8128 19.2909 20.7646 19.1436 19.2435L19.0683 18.4704L19.0569 18.3368C18.9861 17.6197 18.9278 17.0293 19.1025 16.4663C19.2784 15.9 19.6621 15.4523 20.1223 14.9156L20.2079 14.8163L20.7035 14.2373C21.6787 13.0954 22.3467 12.312 22.7418 11.684C23.1312 11.065 23.1301 10.7933 23.0741 10.614C23.0216 10.4461 22.8846 10.2349 22.2325 9.97906C21.5645 9.71528 20.5893 9.49261 19.1562 9.1683L18.4299 9.00386C18.3854 8.99244 18.342 8.98331 18.2998 8.97417C17.6306 8.82344 17.0551 8.6944 16.5834 8.33583C16.1152 7.98184 15.8263 7.45998 15.4826 6.84219L15.4164 6.72115L15.0418 6.05084C14.3042 4.72849 13.7971 3.8218 13.3472 3.23485C12.8984 2.6479 12.6689 2.59765 12.5387 2.59765C12.4086 2.59765 12.179 2.6479 11.7303 3.23485ZM10.3714 2.19341C10.9138 1.48313 11.5864 0.884766 12.5387 0.884766C13.4911 0.884766 14.1626 1.48313 14.7073 2.19341C15.2417 2.89227 15.8092 3.90973 16.5024 5.15329L16.9123 5.88754C17.3599 6.69146 17.4753 6.86275 17.6192 6.97237C17.7562 7.07629 17.9355 7.13567 18.8068 7.33322L19.6061 7.51365C20.949 7.8174 22.0555 8.06748 22.8606 8.38494C23.6965 8.71495 24.4285 9.20027 24.7105 10.1058C24.9892 11.0022 24.6763 11.8267 24.1921 12.5952C23.7216 13.3432 22.9702 14.2225 22.0521 15.2959L21.5097 15.9296C20.9193 16.6194 20.796 16.7884 20.7378 16.9745C20.6795 17.1652 20.6841 17.3856 20.7743 18.3048L20.8554 19.1476C20.9947 20.5819 21.1077 21.7512 21.0678 22.6419C21.0278 23.5497 20.8223 24.4199 20.0743 24.9885C19.3115 25.5664 18.4242 25.5024 17.5678 25.2558C16.7376 25.0182 15.703 24.542 14.4469 23.9631L13.6978 23.6182C12.8779 23.2414 12.7032 23.1809 12.5387 23.1809C12.3743 23.1809 12.1996 23.2414 11.3797 23.6182L10.6317 23.9631C9.37446 24.542 8.33987 25.0182 7.50969 25.2558C6.65325 25.5013 5.76597 25.5664 5.00431 24.9885C4.2552 24.4199 4.04966 23.5497 4.00969 22.643C3.96972 21.7523 4.08277 20.5819 4.22209 19.1487L4.30431 18.3048C4.39338 17.3845 4.39794 17.1652 4.33856 16.9745C4.28147 16.7884 4.15814 16.6205 3.56776 15.9296L3.02535 15.2959C2.10838 14.2225 1.357 13.3432 0.886522 12.5964C0.401203 11.8267 0.0883151 11.0022 0.366945 10.1058C0.649001 9.20027 1.38098 8.71495 2.21687 8.38494C3.02192 8.06748 4.12845 7.8174 5.47135 7.51365L5.5433 7.49766L6.26956 7.33322C7.14199 7.13567 7.32013 7.07629 7.45831 6.97123C7.60219 6.86275 7.71752 6.69146 8.1663 5.88754L8.57511 5.15329C9.26826 3.90859 9.8358 2.89227 10.3702 2.19341"
                                fill="#6C6C6C" />
                        </svg>
                    </span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11.7303 3.23485C11.2803 3.8218 10.7733 4.72849 10.0356 6.05084L9.66222 6.72115L9.59485 6.84219C9.25227 7.45883 8.96108 7.98184 8.49403 8.33583C8.02242 8.6944 7.44689 8.82344 6.77772 8.97417L6.64754 9.00386L5.92127 9.1683C4.48816 9.49261 3.51181 9.71528 2.84492 9.97906C2.19288 10.2349 2.05585 10.4461 2.00333 10.614C1.94737 10.7921 1.94623 11.065 2.33448 11.684C2.73073 12.312 3.39876 13.0954 4.37396 14.2373L4.86956 14.8163L4.9552 14.9156C5.4154 15.4523 5.79909 15.9 5.97494 16.4663C6.14966 17.0293 6.09142 17.6197 6.02062 18.3368L6.0092 18.4704L5.93384 19.2435C5.78538 20.7646 5.68718 21.8128 5.72029 22.5665C5.75455 23.3202 5.91328 23.528 6.04003 23.6239C6.15194 23.7096 6.35977 23.8032 7.03694 23.6091C7.72552 23.4127 8.64134 22.9936 9.98311 22.3758L10.6637 22.0629L10.7882 22.0058C11.4105 21.7169 11.9495 21.468 12.5387 21.468C13.128 21.468 13.667 21.7169 14.2893 22.0047C14.3308 22.0246 14.3726 22.0437 14.4149 22.0618L15.0944 22.3758C16.4361 22.9936 17.352 23.4127 18.0405 23.6091C18.7177 23.8032 18.9255 23.7096 19.0374 23.6239C19.1642 23.528 19.3229 23.319 19.3572 22.5665C19.3914 21.8128 19.2909 20.7646 19.1436 19.2435L19.0683 18.4704L19.0569 18.3368C18.9861 17.6197 18.9278 17.0293 19.1025 16.4663C19.2784 15.9 19.6621 15.4523 20.1223 14.9156L20.2079 14.8163L20.7035 14.2373C21.6787 13.0954 22.3467 12.312 22.7418 11.684C23.1312 11.065 23.1301 10.7933 23.0741 10.614C23.0216 10.4461 22.8846 10.2349 22.2325 9.97906C21.5645 9.71528 20.5893 9.49261 19.1562 9.1683L18.4299 9.00386C18.3854 8.99244 18.342 8.98331 18.2998 8.97417C17.6306 8.82344 17.0551 8.6944 16.5834 8.33583C16.1152 7.98184 15.8263 7.45998 15.4826 6.84219L15.4164 6.72115L15.0418 6.05084C14.3042 4.72849 13.7971 3.8218 13.3472 3.23485C12.8984 2.6479 12.6689 2.59765 12.5387 2.59765C12.4086 2.59765 12.179 2.6479 11.7303 3.23485ZM10.3714 2.19341C10.9138 1.48313 11.5864 0.884766 12.5387 0.884766C13.4911 0.884766 14.1626 1.48313 14.7073 2.19341C15.2417 2.89227 15.8092 3.90973 16.5024 5.15329L16.9123 5.88754C17.3599 6.69146 17.4753 6.86275 17.6192 6.97237C17.7562 7.07629 17.9355 7.13567 18.8068 7.33322L19.6061 7.51365C20.949 7.8174 22.0555 8.06748 22.8606 8.38494C23.6965 8.71495 24.4285 9.20027 24.7105 10.1058C24.9892 11.0022 24.6763 11.8267 24.1921 12.5952C23.7216 13.3432 22.9702 14.2225 22.0521 15.2959L21.5097 15.9296C20.9193 16.6194 20.796 16.7884 20.7378 16.9745C20.6795 17.1652 20.6841 17.3856 20.7743 18.3048L20.8554 19.1476C20.9947 20.5819 21.1077 21.7512 21.0678 22.6419C21.0278 23.5497 20.8223 24.4199 20.0743 24.9885C19.3115 25.5664 18.4242 25.5024 17.5678 25.2558C16.7376 25.0182 15.703 24.542 14.4469 23.9631L13.6978 23.6182C12.8779 23.2414 12.7032 23.1809 12.5387 23.1809C12.3743 23.1809 12.1996 23.2414 11.3797 23.6182L10.6317 23.9631C9.37446 24.542 8.33987 25.0182 7.50969 25.2558C6.65325 25.5013 5.76597 25.5664 5.00431 24.9885C4.2552 24.4199 4.04966 23.5497 4.00969 22.643C3.96972 21.7523 4.08277 20.5819 4.22209 19.1487L4.30431 18.3048C4.39338 17.3845 4.39794 17.1652 4.33856 16.9745C4.28147 16.7884 4.15814 16.6205 3.56776 15.9296L3.02535 15.2959C2.10838 14.2225 1.357 13.3432 0.886522 12.5964C0.401203 11.8267 0.0883151 11.0022 0.366945 10.1058C0.649001 9.20027 1.38098 8.71495 2.21687 8.38494C3.02192 8.06748 4.12845 7.8174 5.47135 7.51365L5.5433 7.49766L6.26956 7.33322C7.14199 7.13567 7.32013 7.07629 7.45831 6.97123C7.60219 6.86275 7.71752 6.69146 8.1663 5.88754L8.57511 5.15329C9.26826 3.90859 9.8358 2.89227 10.3702 2.19341"
                                fill="#6C6C6C" />
                        </svg>
                    </span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11.7303 3.23485C11.2803 3.8218 10.7733 4.72849 10.0356 6.05084L9.66222 6.72115L9.59485 6.84219C9.25227 7.45883 8.96108 7.98184 8.49403 8.33583C8.02242 8.6944 7.44689 8.82344 6.77772 8.97417L6.64754 9.00386L5.92127 9.1683C4.48816 9.49261 3.51181 9.71528 2.84492 9.97906C2.19288 10.2349 2.05585 10.4461 2.00333 10.614C1.94737 10.7921 1.94623 11.065 2.33448 11.684C2.73073 12.312 3.39876 13.0954 4.37396 14.2373L4.86956 14.8163L4.9552 14.9156C5.4154 15.4523 5.79909 15.9 5.97494 16.4663C6.14966 17.0293 6.09142 17.6197 6.02062 18.3368L6.0092 18.4704L5.93384 19.2435C5.78538 20.7646 5.68718 21.8128 5.72029 22.5665C5.75455 23.3202 5.91328 23.528 6.04003 23.6239C6.15194 23.7096 6.35977 23.8032 7.03694 23.6091C7.72552 23.4127 8.64134 22.9936 9.98311 22.3758L10.6637 22.0629L10.7882 22.0058C11.4105 21.7169 11.9495 21.468 12.5387 21.468C13.128 21.468 13.667 21.7169 14.2893 22.0047C14.3308 22.0246 14.3726 22.0437 14.4149 22.0618L15.0944 22.3758C16.4361 22.9936 17.352 23.4127 18.0405 23.6091C18.7177 23.8032 18.9255 23.7096 19.0374 23.6239C19.1642 23.528 19.3229 23.319 19.3572 22.5665C19.3914 21.8128 19.2909 20.7646 19.1436 19.2435L19.0683 18.4704L19.0569 18.3368C18.9861 17.6197 18.9278 17.0293 19.1025 16.4663C19.2784 15.9 19.6621 15.4523 20.1223 14.9156L20.2079 14.8163L20.7035 14.2373C21.6787 13.0954 22.3467 12.312 22.7418 11.684C23.1312 11.065 23.1301 10.7933 23.0741 10.614C23.0216 10.4461 22.8846 10.2349 22.2325 9.97906C21.5645 9.71528 20.5893 9.49261 19.1562 9.1683L18.4299 9.00386C18.3854 8.99244 18.342 8.98331 18.2998 8.97417C17.6306 8.82344 17.0551 8.6944 16.5834 8.33583C16.1152 7.98184 15.8263 7.45998 15.4826 6.84219L15.4164 6.72115L15.0418 6.05084C14.3042 4.72849 13.7971 3.8218 13.3472 3.23485C12.8984 2.6479 12.6689 2.59765 12.5387 2.59765C12.4086 2.59765 12.179 2.6479 11.7303 3.23485ZM10.3714 2.19341C10.9138 1.48313 11.5864 0.884766 12.5387 0.884766C13.4911 0.884766 14.1626 1.48313 14.7073 2.19341C15.2417 2.89227 15.8092 3.90973 16.5024 5.15329L16.9123 5.88754C17.3599 6.69146 17.4753 6.86275 17.6192 6.97237C17.7562 7.07629 17.9355 7.13567 18.8068 7.33322L19.6061 7.51365C20.949 7.8174 22.0555 8.06748 22.8606 8.38494C23.6965 8.71495 24.4285 9.20027 24.7105 10.1058C24.9892 11.0022 24.6763 11.8267 24.1921 12.5952C23.7216 13.3432 22.9702 14.2225 22.0521 15.2959L21.5097 15.9296C20.9193 16.6194 20.796 16.7884 20.7378 16.9745C20.6795 17.1652 20.6841 17.3856 20.7743 18.3048L20.8554 19.1476C20.9947 20.5819 21.1077 21.7512 21.0678 22.6419C21.0278 23.5497 20.8223 24.4199 20.0743 24.9885C19.3115 25.5664 18.4242 25.5024 17.5678 25.2558C16.7376 25.0182 15.703 24.542 14.4469 23.9631L13.6978 23.6182C12.8779 23.2414 12.7032 23.1809 12.5387 23.1809C12.3743 23.1809 12.1996 23.2414 11.3797 23.6182L10.6317 23.9631C9.37446 24.542 8.33987 25.0182 7.50969 25.2558C6.65325 25.5013 5.76597 25.5664 5.00431 24.9885C4.2552 24.4199 4.04966 23.5497 4.00969 22.643C3.96972 21.7523 4.08277 20.5819 4.22209 19.1487L4.30431 18.3048C4.39338 17.3845 4.39794 17.1652 4.33856 16.9745C4.28147 16.7884 4.15814 16.6205 3.56776 15.9296L3.02535 15.2959C2.10838 14.2225 1.357 13.3432 0.886522 12.5964C0.401203 11.8267 0.0883151 11.0022 0.366945 10.1058C0.649001 9.20027 1.38098 8.71495 2.21687 8.38494C3.02192 8.06748 4.12845 7.8174 5.47135 7.51365L5.5433 7.49766L6.26956 7.33322C7.14199 7.13567 7.32013 7.07629 7.45831 6.97123C7.60219 6.86275 7.71752 6.69146 8.1663 5.88754L8.57511 5.15329C9.26826 3.90859 9.8358 2.89227 10.3702 2.19341"
                                fill="#6C6C6C" />
                        </svg>
                    </span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11.7303 3.23485C11.2803 3.8218 10.7733 4.72849 10.0356 6.05084L9.66222 6.72115L9.59485 6.84219C9.25227 7.45883 8.96108 7.98184 8.49403 8.33583C8.02242 8.6944 7.44689 8.82344 6.77772 8.97417L6.64754 9.00386L5.92127 9.1683C4.48816 9.49261 3.51181 9.71528 2.84492 9.97906C2.19288 10.2349 2.05585 10.4461 2.00333 10.614C1.94737 10.7921 1.94623 11.065 2.33448 11.684C2.73073 12.312 3.39876 13.0954 4.37396 14.2373L4.86956 14.8163L4.9552 14.9156C5.4154 15.4523 5.79909 15.9 5.97494 16.4663C6.14966 17.0293 6.09142 17.6197 6.02062 18.3368L6.0092 18.4704L5.93384 19.2435C5.78538 20.7646 5.68718 21.8128 5.72029 22.5665C5.75455 23.3202 5.91328 23.528 6.04003 23.6239C6.15194 23.7096 6.35977 23.8032 7.03694 23.6091C7.72552 23.4127 8.64134 22.9936 9.98311 22.3758L10.6637 22.0629L10.7882 22.0058C11.4105 21.7169 11.9495 21.468 12.5387 21.468C13.128 21.468 13.667 21.7169 14.2893 22.0047C14.3308 22.0246 14.3726 22.0437 14.4149 22.0618L15.0944 22.3758C16.4361 22.9936 17.352 23.4127 18.0405 23.6091C18.7177 23.8032 18.9255 23.7096 19.0374 23.6239C19.1642 23.528 19.3229 23.319 19.3572 22.5665C19.3914 21.8128 19.2909 20.7646 19.1436 19.2435L19.0683 18.4704L19.0569 18.3368C18.9861 17.6197 18.9278 17.0293 19.1025 16.4663C19.2784 15.9 19.6621 15.4523 20.1223 14.9156L20.2079 14.8163L20.7035 14.2373C21.6787 13.0954 22.3467 12.312 22.7418 11.684C23.1312 11.065 23.1301 10.7933 23.0741 10.614C23.0216 10.4461 22.8846 10.2349 22.2325 9.97906C21.5645 9.71528 20.5893 9.49261 19.1562 9.1683L18.4299 9.00386C18.3854 8.99244 18.342 8.98331 18.2998 8.97417C17.6306 8.82344 17.0551 8.6944 16.5834 8.33583C16.1152 7.98184 15.8263 7.45998 15.4826 6.84219L15.4164 6.72115L15.0418 6.05084C14.3042 4.72849 13.7971 3.8218 13.3472 3.23485C12.8984 2.6479 12.6689 2.59765 12.5387 2.59765C12.4086 2.59765 12.179 2.6479 11.7303 3.23485ZM10.3714 2.19341C10.9138 1.48313 11.5864 0.884766 12.5387 0.884766C13.4911 0.884766 14.1626 1.48313 14.7073 2.19341C15.2417 2.89227 15.8092 3.90973 16.5024 5.15329L16.9123 5.88754C17.3599 6.69146 17.4753 6.86275 17.6192 6.97237C17.7562 7.07629 17.9355 7.13567 18.8068 7.33322L19.6061 7.51365C20.949 7.8174 22.0555 8.06748 22.8606 8.38494C23.6965 8.71495 24.4285 9.20027 24.7105 10.1058C24.9892 11.0022 24.6763 11.8267 24.1921 12.5952C23.7216 13.3432 22.9702 14.2225 22.0521 15.2959L21.5097 15.9296C20.9193 16.6194 20.796 16.7884 20.7378 16.9745C20.6795 17.1652 20.6841 17.3856 20.7743 18.3048L20.8554 19.1476C20.9947 20.5819 21.1077 21.7512 21.0678 22.6419C21.0278 23.5497 20.8223 24.4199 20.0743 24.9885C19.3115 25.5664 18.4242 25.5024 17.5678 25.2558C16.7376 25.0182 15.703 24.542 14.4469 23.9631L13.6978 23.6182C12.8779 23.2414 12.7032 23.1809 12.5387 23.1809C12.3743 23.1809 12.1996 23.2414 11.3797 23.6182L10.6317 23.9631C9.37446 24.542 8.33987 25.0182 7.50969 25.2558C6.65325 25.5013 5.76597 25.5664 5.00431 24.9885C4.2552 24.4199 4.04966 23.5497 4.00969 22.643C3.96972 21.7523 4.08277 20.5819 4.22209 19.1487L4.30431 18.3048C4.39338 17.3845 4.39794 17.1652 4.33856 16.9745C4.28147 16.7884 4.15814 16.6205 3.56776 15.9296L3.02535 15.2959C2.10838 14.2225 1.357 13.3432 0.886522 12.5964C0.401203 11.8267 0.0883151 11.0022 0.366945 10.1058C0.649001 9.20027 1.38098 8.71495 2.21687 8.38494C3.02192 8.06748 4.12845 7.8174 5.47135 7.51365L5.5433 7.49766L6.26956 7.33322C7.14199 7.13567 7.32013 7.07629 7.45831 6.97123C7.60219 6.86275 7.71752 6.69146 8.1663 5.88754L8.57511 5.15329C9.26826 3.90859 9.8358 2.89227 10.3702 2.19341"
                                fill="#6C6C6C" />
                        </svg>
                    </span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11.7303 3.23485C11.2803 3.8218 10.7733 4.72849 10.0356 6.05084L9.66222 6.72115L9.59485 6.84219C9.25227 7.45883 8.96108 7.98184 8.49403 8.33583C8.02242 8.6944 7.44689 8.82344 6.77772 8.97417L6.64754 9.00386L5.92127 9.1683C4.48816 9.49261 3.51181 9.71528 2.84492 9.97906C2.19288 10.2349 2.05585 10.4461 2.00333 10.614C1.94737 10.7921 1.94623 11.065 2.33448 11.684C2.73073 12.312 3.39876 13.0954 4.37396 14.2373L4.86956 14.8163L4.9552 14.9156C5.4154 15.4523 5.79909 15.9 5.97494 16.4663C6.14966 17.0293 6.09142 17.6197 6.02062 18.3368L6.0092 18.4704L5.93384 19.2435C5.78538 20.7646 5.68718 21.8128 5.72029 22.5665C5.75455 23.3202 5.91328 23.528 6.04003 23.6239C6.15194 23.7096 6.35977 23.8032 7.03694 23.6091C7.72552 23.4127 8.64134 22.9936 9.98311 22.3758L10.6637 22.0629L10.7882 22.0058C11.4105 21.7169 11.9495 21.468 12.5387 21.468C13.128 21.468 13.667 21.7169 14.2893 22.0047C14.3308 22.0246 14.3726 22.0437 14.4149 22.0618L15.0944 22.3758C16.4361 22.9936 17.352 23.4127 18.0405 23.6091C18.7177 23.8032 18.9255 23.7096 19.0374 23.6239C19.1642 23.528 19.3229 23.319 19.3572 22.5665C19.3914 21.8128 19.2909 20.7646 19.1436 19.2435L19.0683 18.4704L19.0569 18.3368C18.9861 17.6197 18.9278 17.0293 19.1025 16.4663C19.2784 15.9 19.6621 15.4523 20.1223 14.9156L20.2079 14.8163L20.7035 14.2373C21.6787 13.0954 22.3467 12.312 22.7418 11.684C23.1312 11.065 23.1301 10.7933 23.0741 10.614C23.0216 10.4461 22.8846 10.2349 22.2325 9.97906C21.5645 9.71528 20.5893 9.49261 19.1562 9.1683L18.4299 9.00386C18.3854 8.99244 18.342 8.98331 18.2998 8.97417C17.6306 8.82344 17.0551 8.6944 16.5834 8.33583C16.1152 7.98184 15.8263 7.45998 15.4826 6.84219L15.4164 6.72115L15.0418 6.05084C14.3042 4.72849 13.7971 3.8218 13.3472 3.23485C12.8984 2.6479 12.6689 2.59765 12.5387 2.59765C12.4086 2.59765 12.179 2.6479 11.7303 3.23485ZM10.3714 2.19341C10.9138 1.48313 11.5864 0.884766 12.5387 0.884766C13.4911 0.884766 14.1626 1.48313 14.7073 2.19341C15.2417 2.89227 15.8092 3.90973 16.5024 5.15329L16.9123 5.88754C17.3599 6.69146 17.4753 6.86275 17.6192 6.97237C17.7562 7.07629 17.9355 7.13567 18.8068 7.33322L19.6061 7.51365C20.949 7.8174 22.0555 8.06748 22.8606 8.38494C23.6965 8.71495 24.4285 9.20027 24.7105 10.1058C24.9892 11.0022 24.6763 11.8267 24.1921 12.5952C23.7216 13.3432 22.9702 14.2225 22.0521 15.2959L21.5097 15.9296C20.9193 16.6194 20.796 16.7884 20.7378 16.9745C20.6795 17.1652 20.6841 17.3856 20.7743 18.3048L20.8554 19.1476C20.9947 20.5819 21.1077 21.7512 21.0678 22.6419C21.0278 23.5497 20.8223 24.4199 20.0743 24.9885C19.3115 25.5664 18.4242 25.5024 17.5678 25.2558C16.7376 25.0182 15.703 24.542 14.4469 23.9631L13.6978 23.6182C12.8779 23.2414 12.7032 23.1809 12.5387 23.1809C12.3743 23.1809 12.1996 23.2414 11.3797 23.6182L10.6317 23.9631C9.37446 24.542 8.33987 25.0182 7.50969 25.2558C6.65325 25.5013 5.76597 25.5664 5.00431 24.9885C4.2552 24.4199 4.04966 23.5497 4.00969 22.643C3.96972 21.7523 4.08277 20.5819 4.22209 19.1487L4.30431 18.3048C4.39338 17.3845 4.39794 17.1652 4.33856 16.9745C4.28147 16.7884 4.15814 16.6205 3.56776 15.9296L3.02535 15.2959C2.10838 14.2225 1.357 13.3432 0.886522 12.5964C0.401203 11.8267 0.0883151 11.0022 0.366945 10.1058C0.649001 9.20027 1.38098 8.71495 2.21687 8.38494C3.02192 8.06748 4.12845 7.8174 5.47135 7.51365L5.5433 7.49766L6.26956 7.33322C7.14199 7.13567 7.32013 7.07629 7.45831 6.97123C7.60219 6.86275 7.71752 6.69146 8.1663 5.88754L8.57511 5.15329C9.26826 3.90859 9.8358 2.89227 10.3702 2.19341"
                                fill="#6C6C6C" />
                        </svg>
                    </span>
                </p>
            </div>


            <form>
                <div class="row">
                    <div class="col-md-6">
                        <input type="text" class="form-control" :placeholder="$t('form.name')" aria-label="First name">
                    </div>
                    <div class="col-md-6">
                        <input type="email" class="form-control " :placeholder="$t('form.email')" aria-label="email">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <textarea class="form-control" rows="6" :placeholder="$t('leaveComment')"></textarea>
                    </div>
                </div>
                <button type="submit"> {{ $t('addNow') }} </button>
            </form>

        </div>
    </section> -->
    </section>
</template>
<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'
// import StarRating from 'vue-star-rating';
import RatingComponent from '../Common/RatingComponent.vue'
export default {
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
        RatingComponent
    },
    data() {
        return {
            direction: localStorage.getItem("direction") || "rtl",
            AssestURL: process.env.VUE_APP_ASSETS_URL,
            props: {
                // showLine: {
                //     type: Boolean,
                //     value: true
                // },
                applyContainer: {
                    type: Boolean,
                    value: true
                },
                hideLike: {
                    type: Boolean,
                    value: false
                }
            },

            settings: {
                itemsToShow: 2,
                snapAlign: "start",
            },
            // breakpoints are mobile first
            // any settings not specified will fallback to the carousel settings
            breakpoints: {
                // 700px and up
                700: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                900: {
                    itemsToShow: 3,
                    snapAlign: "center",
                },
                // 1024 and up
                1024: {
                    itemsToShow: 4,
                    snapAlign: "start",
                },
            },
        }
    },
    computed: {
        slidesContent() {
            return this.$store.getters.reviews
        }
    },
    mounted() {
        window.addEventListener("direction-localstorage-changed", (event) => {
            this.direction = event.detail.storage;
        });
        this.$store.dispatch('fetchReviews')
        //console.log(this.slidesContent)
    },
}
</script>
<style lang="scss" scoped>
.container {
    margin-top: 60px;
}

.like.hide {
    display: none !important;
}

hr {
    background: #707879 !important;
    height: 3px !important;
}

.student-reviews .our-clients .carousel .carousel__pagination .carousel__pagination-item .carousel__pagination-button::after {
    width: 15px !important;
    height: 15px !important;
    border-radius: 50% !important;
    background: #f2f2 !important;
}

/**************End Of rating Progress Section***********************/
/**************start Of Students reviews ***********************/
img {
    width: 100%;
    height: auto;
}

.text,
.profile-cards {
    &:lang(ar) {
        text-align: right;
    }

    &:lang(en) {
        text-align: left;
    }
}

.text {
    color: #6C6C6C;
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 2.5rem;
    text-transform: capitalize;
    margin-top: 15px;
}

.profile-cards {
    width: 98%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin: 10px auto;
    align-items: center;
    padding-top: 100px;
    padding-bottom: 20px;

    .card {
        position: relative;
        background-color: whitesmoke;
        padding: 28px 32px;
        border-radius: 10px;
        background: #FFF;
        // box-shadow: 0px 10px 60px 0px rgba(0, 0, 0, 0.08);
        transition: all 0.5s;
        border-radius: 10px;

        img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            object-fit: cover;
            border: 5px solid whitesmoke;
            margin-top: -110.5px;
        }
    }

    .img-box {
        width: 120px;
    }

    .like {
        &:lang(ar) {
            margin-right: auto;
        }

        &:lang(en) {
            margin-left: auto;
        }

        flex: 1;

        span:nth-of-type(1) {
            &:lang(ar) {
                margin-left: 8px;
            }

            &:lang(en) {
                margin-right: 8px;
            }
        }
    }

    .name-container {
        text-align: justify;

        h2 {
            margin-bottom: 10px;
        }

        &:lang(ar) {
            margin-left: 38px;
        }

        &:lang(en) {
            margin-right: 38px;
        }
    }
}

.card img {
    position: absolute;
    bottom: 70%;

    &:lang(ar) {
        right: 5%
    }

    &:lang(en) {
        left: 5%;
    }
}

.name {
    color: #3B3A3A;
    font-size: 1.5625rem;
    font-weight: 700;
    text-transform: capitalize;
}

.card:hover {
    transform: translateY(-1px);
}

/*********************Add review******************************/
.add-review {
    margin-top: 50px;
    padding-bottom: 35px;
    padding-right: 15px;

    &:lang(ar) {
        padding-right: 15px;
    }

    &:lang(en) {
        padding-left: 15px;
    }

    h4 {
        color: #000;
        font-size: 1.5625rem;
        font-weight: 700;
        line-height: 160%;
        letter-spacing: -0.25px;
    }

    input,
    textarea {
        margin-bottom: 15px;
        border-radius: 2px;
        background: #F3F6F6;
        padding: 10px 12px;
    }

    ::placeholder,
    textarea {
        padding: 17px 10px;
        color: #707070;
        font-size: .875rem;
        font-weight: 400;
        line-height: 160%;
        letter-spacing: -0.14px;
        text-transform: capitalize;
    }

    button {
        color: #F5F5F5;
        display: inline-flex;
        padding: 10px 32px;
        justify-content: center;
        align-items: center;
        gap: 6px;
        flex-shrink: 0;
        font-size: 1rem;
        font-weight: 700;
        line-height: 160%;
        letter-spacing: -0.16px;
        text-transform: capitalize;
        border-radius: 4px;
        background: #206387;
        border: 1px solid #206387;
        transition: all 0.5s ease-in-out;

        &:hover {
            cursor: pointer;
            background-color: transparent;
            color: #206387;
            transform: translateX(-10px);
        }
    }

    .rate {
        margin-top: 10px;
        margin-bottom: 22px;

        p:nth-of-type(1) {
            color: #707070;
            font-size: 1.25rem;
            font-weight: 500;
            line-height: 160%;
            letter-spacing: -0.2px;
            text-transform: capitalize;

            &:lang(ar) {
                margin-left: 15px;
            }

            &:lang(en) {
                margin-right: 15px;
            }
        }
    }
}

.form-control:focus {
    box-shadow: none;
    border: 1px solid #2EA2CE;
}

.custom-container-1 {
    width: 60%;
}

/***************media queries*******************************/
@media (max-width: 575.98px) {
    .name {
        &:lang(ar) {
            padding-right: 101px;
        }

        &:lang(en) {
            padding-left: 101px;
        }
    }
}

@media screen and (max-width:1200px) {
    .profile-cards .name-container {
        h2 {
            margin-top: 40px;
        }
    }
}

@media (max-width: 768px) {
    .profile-cards .card img {
        width: 7rem;
        height: 7rem;
    }

    .card img {
        bottom: 98%;
    }

    .name {
        &:lang(ar) {
            padding-right: 0;
            text-align: right;
        }

        &:lang(en) {
            padding-left: 0;
            text-align: left;
        }

        padding-top: 25px;
    }

    .profile-cards {
        .card {
            padding: 0 15px;
            padding-bottom: 30px;
        }

        img {
            margin-bottom: -38px;
            margin-top: 0;
        }

        .like {
            &:lang(ar) {
                margin-right: 10px;
            }

            &:lang(en) {
                margin-left: 10px;
            }

            margin-top: -18px;
        }
    }

    .name {
        padding-top: 70px;
    }
}

@media (max-width:991.98px) {
    .profile-cards .card {
        margin-bottom: 20px;
    }

}

@media (min-width:992px) and (max-width: 1200px) {
    .name {
        &:lang(ar) {
            padding-right: 50px;
        }

        &:lang(en) {
            padding-left: 50px;
        }

        font-size: 1.25rem;
    }

    .custom-container-1 {
        width: 95%;
    }

    .profile-cards .card {
        margin-bottom: 30px;
    }

    .profile-cards .like span:nth-of-type(1) {
        &:lang(ar) {
            margin-left: 0;
        }

        &:lang(en) {
            margin-right: 0;
        }
    }
}

/**************End Of Students reviews***********************/
</style>
